import { render, staticRenderFns } from "./LinkedInPreview.vue?vue&type=template&id=2904ed56&scoped=true&"
import script from "./LinkedInPreview.vue?vue&type=script&lang=ts&"
export * from "./LinkedInPreview.vue?vue&type=script&lang=ts&"
import style0 from "./LinkedInPreview.vue?vue&type=style&index=0&id=2904ed56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2904ed56",
  null
  
)

export default component.exports